import React from 'react';
import { StatutColis } from '../../types';
import { useTranslation } from '../../hooks/useTranslation';

interface BadgeProps {
  statut: StatutColis;
}

const STATUT_COLORS: Record<StatutColis, { bg: string; text: string }> = {
  [StatutColis.CREE]: { bg: 'bg-gray-100', text: 'text-gray-800' },
  [StatutColis.EN_ATTENTE_RAMASSAGE]: { bg: 'bg-amber-100', text: 'text-amber-800' },
  [StatutColis.RAMASSE]: { bg: 'bg-cyan-100', text: 'text-cyan-800' },
  [StatutColis.EN_TRANSIT]: { bg: 'bg-blue-100', text: 'text-blue-800' },
  [StatutColis.ARRIVE]: { bg: 'bg-purple-100', text: 'text-purple-800' },
  [StatutColis.AFFECTE_LIVREUR]: { bg: 'bg-indigo-100', text: 'text-indigo-800' },
  [StatutColis.EN_LIVRAISON]: { bg: 'bg-yellow-100', text: 'text-yellow-800' },
  [StatutColis.LIVRE]: { bg: 'bg-green-100', text: 'text-green-800' },
  [StatutColis.LIVRAISON_ECHOUEE]: { bg: 'bg-red-100', text: 'text-red-800' },
  [StatutColis.RETOUR_EN_COURS]: { bg: 'bg-pink-100', text: 'text-pink-800' },
  [StatutColis.RETOURNE]: { bg: 'bg-rose-100', text: 'text-rose-800' },
  [StatutColis.ANNULE]: { bg: 'bg-red-100', text: 'text-red-800' },
  [StatutColis.EN_DEDOUANEMENT]: { bg: 'bg-orange-100', text: 'text-orange-800' },
  [StatutColis.PRET_RETRAIT]: { bg: 'bg-teal-100', text: 'text-teal-800' },
  [StatutColis.EN_PREPARATION]: { bg: 'bg-sky-100', text: 'text-sky-800' },
  [StatutColis.LIVREUR_SUR_PLACE]: { bg: 'bg-lime-100', text: 'text-lime-800' },
  [StatutColis.INJOIGNABLE]: { bg: 'bg-orange-100', text: 'text-orange-800' },
  [StatutColis.REPORTE]: { bg: 'bg-amber-100', text: 'text-amber-800' },
  [StatutColis.ADRESSE_INTROUVABLE]: { bg: 'bg-orange-100', text: 'text-orange-800' },
  [StatutColis.ABSENT]: { bg: 'bg-orange-100', text: 'text-orange-800' },
  [StatutColis.REFUSE]: { bg: 'bg-red-100', text: 'text-red-800' },
  [StatutColis.PAIEMENT_REFUSE]: { bg: 'bg-red-100', text: 'text-red-800' },
};

export const Badge: React.FC<BadgeProps> = ({ statut }) => {
  const t = useTranslation();
  const colors = STATUT_COLORS[statut];
  const label = t.statuts[statut];

  return (
    <span className={`px-2 py-1 text-xs font-medium rounded-full ${colors.bg} ${colors.text}`}>
      {label}
    </span>
  );
};
